import React from 'react';

import { TEnvironmentContext } from 'types/EnvironmentContext';

const defaultValues: TEnvironmentContext = {
  staticBaseUrl: '',
  xsrfToken: '',
  tenantContext: {
    tenant: 'mp',
    locale: 'nl',
  },
  baseUrl: '',
  links: {
    expiredTokenRedirectUrl: '',
    homePageRedirectUrl: `/`,
    validatedTargetUrl: '',
    loginRedirectUrl: '',
    tmxScriptUrl: '',
    tmxIframeUrl: '',
  },
  social: {
    googleSdkUrl: '',
    googleClientID: '',
  },
  threatMetrix: {
    timestamp: 1,
    signature: '',
    uuid: '',
    domain: '',
    pageID: 11,
  },
  expired: false,
  force: false,
  defaultCountryCode: 'NL',
  twoFactorAuthSetupChange: false,
  tamperedRecoveryPhoneNumber: '',
  is2FAEnabled: false,
  userDetails: {},
  emailNewsletterOptin: false,
  recaptchaScriptUrl: '',
  username: '',
  email: '',
  recaptchaSiteKey: '',
  marketingPreferencesUserId: '',
  marketingPreferencesType: '',
  experiments: {
    force2FAEnabled: false,
    accountDefenderEnabled: false,
    disposableDomainCheckEnabled: false,
    ipAbuseDetectionEnabled: false,
  },
};

const EnvironmentContext = React.createContext(defaultValues);

export const EnvironmentProvider = EnvironmentContext.Provider;
export const EnvironmentConsumer = EnvironmentContext.Consumer;

export default EnvironmentContext;
